import { getSubjects, getChapter } from './api'
import { userSlice } from './reducer'

const {
  resetChapters,
  setSelectedChapter,
  setSelectedTopic,
  resetSelectedTopic,
  selectedMaterial,
  updateHasError
} = userSlice.actions

export {
  getSubjects,
  getChapter,
  resetChapters,
  setSelectedChapter,
  setSelectedTopic,
  resetSelectedTopic,
  selectedMaterial,
  updateHasError
}
